import { formatNumber } from "../lib/formatters.js";
import { buildBlogPath, buildShowPath } from "../lib/routes.js";

export function HomePage({ shows, credits = [] }) {
  const element = document.createElement("section");
  element.className = "page-shell home-page";

  element.innerHTML = `
    <div class="home-intro">
      <p class="home-eyebrow">
        <span class="home-eyebrow-desktop">TV AGE EXPLORER — it hits different when you're their age.</span>
        <span class="home-eyebrow-mobile">TV AGE EXPLORER — don't feel too old</span>
      </p>
      <h1 class="home-title">How old were the actors here?</h1>
      <p class="home-desc">
        Pick a show, open a season, tap an episode — see actors’ ages on the original air date.
      </p>
    </div>
    <div class="show-grid" aria-label="Shows">
      ${shows
        .map((show, index) => {
          const heroToUse = show.homeHero || show.hero;
          const isLcpCandidate = index === 0;
          return `
          <a class="show-card" data-link href="${buildShowPath(show.id)}">
            <div class="show-card-media">
              <img
                src="${heroToUse.src}"
                alt="${heroToUse.alt}"
                style="object-position:${heroToUse.objectPosition};"
                loading="${isLcpCandidate ? "eager" : "lazy"}"
                ${isLcpCandidate ? 'fetchpriority="high"' : ""}
                decoding="async"
              />
            </div>
            <div class="show-card-body">
              <div class="show-card-topline">
                <span class="tag">${show.years.replace("-", "–")}</span>
                <span class="tag">${formatNumber(show.totalEpisodes)} eps</span>
              </div>
              <h2 class="show-card-title">${show.title}</h2>
              <p class="show-card-creator">${show.creator}</p>
            </div>
          </a>
            `;
        })
        .join("")}
    </div>
    <div class="home-footer-meta">
      <span class="tag tag--sky">${formatNumber(shows.length)} shows</span>
    </div>
    <div class="home-credits">
      <a class="text-link home-credits-link" data-link href="${buildBlogPath()}">Blog</a>
      <span class="home-credits-sep">·</span>
      <a class="text-link home-credits-link" href="/credits">Credits</a>
    </div>
  `;

  const creditsLink = element.querySelector('a[href="/credits"]');
  creditsLink?.addEventListener("click", async (event) => {
    event.preventDefault();
    try {
      const { openCreditsModal } = await import("../components/CreditsModal.js");
      openCreditsModal({ credits });
    } catch {
      window.location.assign(new URL("credits", document.baseURI).href);
    }
  });

  return {
    title: "How Old Were the Actors? TV Cast Ages | HowOldHere",
    element,
  };
}
